import {type FancyOk, type fancyOperations} from '@frontrow/console/src/open-api/clients'

/**
 * `getDistrictsR`, `postDistrictsR`, `patchDistrictR` and the `district` on a
 * `getTeachersR` row are all the same object. Only its timestamps change type.
 */
export type DistrictT = Omit<
  FancyOk<fancyOperations['getDistrictsR']>[number],
  'createdAt' | 'updatedAt'
> & {
  createdAt: Date
  updatedAt: Date
}

export function fromOpenApiDistrict(
  response: FancyOk<fancyOperations['getDistrictsR']>[number]
): DistrictT {
  return {
    ...response,
    createdAt: new Date(response.createdAt),
    updatedAt: new Date(response.updatedAt)
  }
}

export function fromOpenApiDistricts(
  response: Array<FancyOk<fancyOperations['getDistrictsR']>[number]>
): Array<DistrictT> {
  return response.map(fromOpenApiDistrict)
}

/**
 * The district form's state and the `postDistrictsR` body: a district without
 * the keys the server assigns.
 */
export type BasicDistrictT = Omit<DistrictT, 'id' | 'createdAt' | 'updatedAt' | 'crmAccountNumber'>
